// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mWQX","largestCol":"styles_largestCol__2gFUV","smallestCol":"styles_smallestCol__2Ylzq"};